<template>
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
    @click.self="$emit('close')"
  >
    <div class="bg-white rounded-xl p-6 max-w-sm w-full">
      <h2 class="text-xl font-bold mb-1">{{ $t('about.title') }}</h2>
      <p class="text-sm text-gray-500 mb-4">{{ $t('about.copyright', { year: currentYear }) }}</p>

      <div class="border-t border-gray-100 pt-4 mb-6">
        <p class="text-gray-700 text-sm mb-3">{{ $t('about.contactMessage') }}</p>
        <div class="space-y-2">
          <a
            href="mailto:info@lunca.de"
            class="flex items-center gap-2 text-primary-600 hover:text-primary-500 text-sm transition-colors"
          >
            <span>📧</span>
            <span>info@lunca.de</span>
          </a>
          <a
            href="mailto:christoph.kleih@web.de"
            class="flex items-center gap-2 text-primary-600 hover:text-primary-500 text-sm transition-colors"
          >
            <span>📧</span>
            <span>christoph.kleih@web.de</span>
          </a>
        </div>
      </div>

      <button @click="$emit('close')" class="btn btn-primary w-full">
        {{ $t('common.close') }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineEmits(['close'])

const currentYear = new Date().getFullYear()
</script>
